import PopFilterButton from './PopFilterButton';
import { useUrlParams } from '../../../../../hooks';
import { useDiscoverStore } from '../../../../../zustand-stores';
import { ProgramType } from '../../../../../shared/program-type-enum';
import toggleArrayItem from '../../../../../zustand-stores/DiscoverStore/utils/toggleArrayItem';

interface Props {
  programType: keyof typeof ProgramType;
}

const ProgramTypePopFilter = ({ programType }: Props) => {
  const { updateUrlParams } = useUrlParams();

  const selectedProgramTypes = useDiscoverStore(
    store => store.filters.selectedProgramTypes
  ) as string[];

  const onPressProgramType = () =>
    updateUrlParams({
      programTypes: toggleArrayItem(selectedProgramTypes, programType),
    });

  return (
    <PopFilterButton
      onPress={onPressProgramType}
      label={ProgramType[programType]?.name || ''}
      pressed={selectedProgramTypes.includes(programType)}
    />
  );
};

export default ProgramTypePopFilter;
